<template>
  <section class="panel" :class="[setType, setHeight, customClass]">
    <header class="panel-header" :class="{ 'justify-content-between': between, 'mb-0': subTitle }" v-if="$slots.headline || $slots.headerContent">
      <h2 class="headline panel-headline" :class="{ 'w-100': isPointEvent && hasPointCpm }"><slot name="headline"></slot></h2>
      <slot name="headerContent"></slot>
      <div class="headline panel-headline"><slot name="headlineStatus"></slot></div>
    </header>
    <p
      v-if="subTitle"
      class="panel-subtitle"
    >
      {{ subTitle }}
    </p>
    <slot v-if="$slots.tab" name="tab"></slot>
    <div
      v-if="type === 'sheet'"
      class="panel-body"
      :class="[setColor, setLink, setPadding, { 'panel-body-point': isPoint, 'pd-0': hasDataPoint }]"
    >
      <slot name="body"></slot>
    </div>
    <div class="panel-content" :class="setLink" v-if="type === 'board'">
      <div class="panel-body" :class="[setColor, setPadding, { 'panel-body-center': center, 'pd-0': hasDataPoint }]">
        <slot name="body"></slot>
      </div>
      <span v-if="$slots.tooltip"><slot name="tooltip"></slot></span>
      <div class="panel-content-footer" v-if="$slots.contentFooter">
        <slot name="contentFooter"></slot>
      </div>
    </div>
    <footer class="panel-footer" :class="{ 'no-border': hasFooterBorder }" v-if="$slots.footer"><slot name="footer"></slot></footer>
  </section>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  type: String,
  customClass: String,
  color: String,
  link: {
    type: Boolean,
    default: false,
  },
  padding: {
    type: Boolean,
    default: true,
  },
  center: {
    type: Boolean,
    default: false,
  },
  height: {
    type: Boolean,
    default: true,
  },
  between: {
    type: Boolean,
    default: false,
  },
  isPoint: {
    type: Boolean,
    default: false,
  },
  isPointEvent: {
    type: Boolean,
    default: false,
  },
  hasDataPoint: {
    type: Boolean,
    default: false,
  },
  isNotBorderShadow: {
    type: Boolean,
    default: false,
  },
  hasFooterBorder: {
    type: Boolean,
    default: false,
  },
  subTitle: {
    type: Boolean,
    default: false,
  },
  hasPointCpm: {
    type: Boolean,
    default: true,
  },
});

const setType = computed(() => {
  switch (props.type) {
    case 'sheet':
      return 'panel-sheet';
    case 'board':
      return 'panel-board';
    default:
      return false;
  }
});
const setColor = computed(() => {
  if (props.color) {
    switch (props.color) {
      case 'blue':
        return 'panel-blue';
      case 'green':
        return 'panel-green';
      case 'red':
        return 'panel-red';
      case 'yellow':
        return 'panel-yellow';
      case 'purple':
        return 'panel-purple';
      case 'deeppink':
        return 'panel-deeppink';
    }
  }
  return false;
});
const setLink = computed(() => ({
  'panel-link': props.link,
  'panel-no-shadow': props.isNotBorderShadow,
}));
const setPadding = computed(() => ({
  'panel-body-p0': !props.padding,
}));
const setHeight = computed(() => ({
  'panel-height-auto': !props.height,
}));
</script>

<style scoped>
.panel-no-shadow {
  box-shadow: none !important;
}

.no-border {
  border: none !important;
}
.panel-subtitle {
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 32px;
}
</style>